export const MicrosoftIcon = () => (
    <svg width="32px" height="32px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="17" y="17" width="10" height="10" fill="#FEBA08"/>
        <rect x="5" y="17" width="10" height="10" fill="#05A6F0"/>
        <rect x="17" y="5" width="10" height="10" fill="#80BC06"/>
        <rect x="5" y="5" width="10" height="10" fill="#F25325"/>
    </svg>
);


export const MinecraftIcon = () => (
    <svg
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="32" height="32" fill="#3A8A3A" />
        <rect x="8" y="10" width="6" height="6" fill="#0F1F0F" />
        <rect x="18" y="10" width="6" height="6" fill="#0F1F0F" />
        <rect x="12" y="18" width="8" height="8" fill="#0F1F0F" />
        <rect x="10" y="20" width="4" height="6" fill="#0F1F0F" />
        <rect x="18" y="20" width="4" height="6" fill="#0F1F0F" />
    </svg>
);
